import React, { useEffect, useState } from "react";
import pdf from "@react-pdf/renderer";
import { Modal } from "antd";
import GeneratePDF from "./GeneratePDF";
import { QueryList } from "../constants/Helpers";

const PDFModal = ({ ...props }) => {
  const { PDFViewer } = pdf;
  const [dataArray, setDataArray] = useState({ titles: [], keys: [], data: [], pdfTitle: "" });

  useEffect(() => {
    const tempDataArray = { titles: [], keys: [], data: [], pdfTitle: "" };
    switch (props.fromScreen) {
      case "TCL":
        tempDataArray.pdfTitle = "Traffic/Criminal Lookup Results";
        tempDataArray.titles = ["Case", "Name", "DOB", "Offense", "Date", "Status"];
        tempDataArray.keys = ["CASE", "NAME", "DATE_OF_BIRTH", "OFFENSE", "VIOLATION_DATE", "STATDEF"];
        break;
      case "CL":
        tempDataArray.pdfTitle = "Civil Lookup Results";
        tempDataArray.titles = ["Case Number", "Plaintiff", "Defendant", "Status"];
        tempDataArray.keys = ["CaseNumber", "PrimaryPlaintiffName", "PrimaryDefendantName", "CaseStatusCodeFK"];
        break;
      case "AW":
        tempDataArray.pdfTitle = "Active Warrant Results";
        tempDataArray.titles = ["Case", "Name", "DOB", "Offense", "Date", "Status"];
        tempDataArray.keys = ["CASE", "NAME", "DATE_OF_BIRTH", "OFFENSE", "VIOLATION_DATE", "STATDEF"];
        break;
      case QueryList.TRCRDaily:
        tempDataArray.pdfTitle = "Traffic/Criminal Query ~ Daily Case Schedule Query Results";
        tempDataArray.titles = ["Judge", "Room", "Date", "Time", "Case", "Name", "Voilation", "Agency", "Attorney", "Prosecutor", "Status"];
        tempDataArray.keys = ["JUDGE", "ROOM", "DATE", "TIME", "CASE", "NAME", "VOILATIONS", "AGENCY", "ATTORNEY", "PROSECUTOR", "STATUS"];
        break;
      case QueryList.TRCRArraignment:
        tempDataArray.pdfTitle = "Traffic/Criminal Query ~ Arraignment Case Schedule Query Results";
        tempDataArray.titles = ["Judge", "Room", "Date", "Time", "Case", "Name", "Voilation", "Agency"];
        tempDataArray.keys = ["JUDGE", "ROOM", "DATE", "TIME", "CASE", "NAME", "VOILATIONS", "AGENCY"];
        break;
      case QueryList.TRCRAttorney:
        tempDataArray.pdfTitle = "Traffic/Criminal Query ~ Attorney Case Schedule Query Results";
        tempDataArray.titles = ["Attorney", "Date", "Time", "Case", "Name", "Voilation", "Status"];
        tempDataArray.keys = ["ATTORNEY", "DATE", "TIME", "CASE", "NAME", "VOILATIONS", "STATUS"];
        break;
      case QueryList.TRCRAgency:
        tempDataArray.pdfTitle = "Traffic/Criminal Query ~ Agency Case Schedule Query Results";
        tempDataArray.titles = ["Officer", "Agency", "Date", "Time", "Case", "Voilation"];
        tempDataArray.keys = ["OFFICER", "Agency", "DATE", "TIME", "CASE", "VOILATIONS"];
        break;
      case QueryList.CivilDaily:
        tempDataArray.pdfTitle = "Civil Query ~ Daily Case Schedule Query Results";
        tempDataArray.titles = ["Judge", "Case", "Plantiffs", "Status", "Dependents"];
        tempDataArray.keys = ["JudgeName", "CaseNumber", "PlaintiffList", "Description", "DefendantList"];
        break;
      case QueryList.CivilAttorney:
        tempDataArray.pdfTitle = "Civil Query ~ Attorney Case Schedule Query Results";
        tempDataArray.titles = ["Attorney", "Case", "Plantiffs", "Status", "Dependents"];
        tempDataArray.keys = ["AttorneyName", "CaseNumber", "PlaintiffList", "Description", "DefendantList"];
        break;
    }
    props?.data?.forEach((eachValue) => {
      let tempFields = {};
      tempDataArray?.keys?.forEach((eachKey) => {
        tempFields[eachKey] = eachValue[eachKey]?.replaceAll("<br />", ",");
      });
      tempDataArray?.data?.push(tempFields);
    });
    setDataArray(tempDataArray);
  }, [props.data]);

  return (
    <Modal visible={props.visibility} width={1000} footer={[]} style={{ top: 20 }} onCancel={() => props.setVisibility(false)}>
      <div style={{ textAlign: "center" }}>
        <PDFViewer className="pdf-viewer" style={{ flex: 1 }}>
          <GeneratePDF data={JSON.stringify(dataArray)} />
        </PDFViewer>
      </div>
    </Modal>
  );
};

export default PDFModal;
